import React from 'react';
import OrderFilePanel from './OrderFilePanel';
import { ordersApi } from '../services/api';

/**
 * Factory Processing Sheet panel — Order Detail (internal side).
 * Excel only. Same gate as the Manufacturing Order Form — the order stays
 * hidden from the factory portal until this sheet is uploaded.
 */
export default function FactoryProcessingSheetCard({ order, onChanged }) {
  const hasFactory = !!order?.factory_id;
  const gateRelevant = hasFactory && (order?.pieces_to_factory || 0) > 0;
  if (!gateRelevant && !order?.factory_processing_sheet) return null;

  return (
    <OrderFilePanel
      order={order}
      fieldKey="factory_processing_sheet"
      label="Factory Processing Sheet"
      allowedExts={['xls', 'xlsx', 'xlsm']}
      acceptAttr=".xls,.xlsx,.xlsm,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      description="Upload the Excel Processing Sheet the factory needs to run this order. Same gate as the Manufacturing Order Form — the order will NOT appear on the factory portal until this sheet is uploaded."
      uploadFn={ordersApi.uploadFactoryProcessingSheet}
      deleteFn={ordersApi.deleteFactoryProcessingSheet}
      downloadUrlFn={ordersApi.getFactoryProcessingSheetUrl}
      onChanged={onChanged}
    />
  );
}
